import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhotoLibraryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"photo_library"}/>
}
